"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 19V3H5v16H3v2h18v-2zm-4-6h-2v-2h2z"
}), 'DoorFrontSharp');